// The small icon badge next to the user's name (sidebar.jsx) when they're on
// PRO/PREMIUM — see hooks/usePlanAccent.js for the logo-ring counterpart.
export default function PlanChip({ accent }) {
    if (!accent) return null;
    return (
        <span className={`plan-chip plan-chip-${accent}`} aria-hidden="true">
            <i className={`bi ${accent === 'premium' ? 'bi-gem' : 'bi-lightning-charge-fill'}`} />
        </span>
    );
}
